import { render, staticRenderFns } from "./NodeAction.vue?vue&type=template&id=5b705ba2"
import script from "./NodeAction.vue?vue&type=script&lang=js"
export * from "./NodeAction.vue?vue&type=script&lang=js"
import style0 from "./NodeAction.vue?vue&type=style&index=0&id=5b705ba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports